<template>
  <el-card :body-style="{ padding: '20px', height: '100%' }" class="h-full">
    <el-row>
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        size="small"
        clearable
        v-model="keyword"
        placeholder="请输入"
        class="w-200px ml-10px mr-10px"
      >
      </el-input>
      <el-button type="primary" size="small" @click="searchTableData">搜索</el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!$hasAccess('create')"
        @click="handleAdd('add')"
        >新增</el-button
      >
      <el-button
        type="primary"
        size="small"
        :disabled="!$hasAccess('enable')"
        @click="batchEnable(selectionList)"
        >启用</el-button
      >
      <el-button
        type="danger"
        size="small"
        :disabled="!$hasAccess('delete')"
        @click="batchDelete(selectionList)"
        >删除</el-button
      >
    </el-row>
    <el-table
      class="mt-20px"
      border
      :data="tableData"
      v-loading="tableLoading"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      height="calc(100% - 106px)"
      ref="multipleTable"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="55"></el-table-column>
      <el-table-column label="订阅编码" prop="code" show-overflow-tooltip></el-table-column>
      <el-table-column label="订阅名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="订阅类型"
        prop="subscribeTypeName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="备注" prop="remark" show-overflow-tooltip> </el-table-column>
      <el-table-column label="创建人" prop="createdUserName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdTime" show-overflow-tooltip> </el-table-column>
      <el-table-column label="是否启用" prop="isEnabled">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isEnabled"
            @change="handleisEnable(scope.row.isEnabled, [scope.row.id])"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('operate')}`" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="!$hasAccess('read')"
            @click="handleAdd('read', scope.row)"
            >{{ $t('view') }}</el-button
          >
          <el-button
            size="mini"
            :disabled="!$hasAccess('update')"
            @click="handleAdd('update', scope.row)"
            >{{ $t('edit') }}</el-button
          >
          <el-button
            size="mini"
            :disabled="!$hasAccess('delete')"
            @click="batchDelete([scope.row.id])"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px float-right"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      :page-sizes="$pageSizeAll"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>

    <!-- 新增订阅发布 -->
    <addSubscribePublish :dialogForm="dialogForm" @refresh="searchTableData" />
  </el-card>
</template>

<script>
import SubscribePublishService from '@/services/SubscribePublishService'
import addSubscribePublish from './components/addSubscribePublish'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'subscriptionApplication',
  components: { addSubscribePublish, selectStandardId },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      keyword: '',
      tableData: [],
      tableLoading: false,
      selectionList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dialogForm: {
        visible: false,
        type: '',
        id: '',
      },
    }
  },
  methods: {
    handleisEnable(status, id) {
      if (status) {
        this.batchEnable(id)
      } else {
        this.batchDisable(id)
      }
    },
    // 批量删除
    batchDelete(ids) {
      if (ids.length > 0) {
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await SubscribePublishService.delSubscribeApply(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.warning('请选择要删除的数据')
      }
    },
    // 批量启用
    async batchEnable(ids) {
      if (ids.length > 0) {
        const res = await SubscribePublishService.enable(ids)
        if (res && res.code === 0) {
          this.$message.success('启用成功')
          this.searchTableData()
        }
      } else {
        this.$message.warning('请选择要启用的数据')
      }
    },
    // 批量禁用
    async batchDisable(ids) {
      if (ids.length > 0) {
        const res = await SubscribePublishService.disable(ids)
        if (res && res.code === 0) {
          this.$message.success('禁用成功')
          this.searchTableData()
        }
      } else {
        this.$message.warning('请选择要禁用的数据')
      }
    },
    updateStandardId(val) {
      this.standardId = val
    },
    handleSelectionChange(val) {
      this.selectionList = _.map(val, (item) => {
        return item.id
      })
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    async searchTableData() {
      const res = await SubscribePublishService.geDataList({
        StandardId: this.standardId,
        Filter: this.keyword,
        Sorting: '',
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    handleAdd(type, row) {
      this.dialogForm.type = type
      if (type === 'add') {
        this.dialogForm.visible = true
      } else {
        this.dialogForm.id = row.id
        this.dialogForm.visible = true
      }
    },
  },
  created() {
    this.searchTableData()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>
